class CreatorTestimonials extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.creator-testimonials__slider');
    this.videos = this.querySelectorAll('.creator-testimonials__video-player');

    if (this.slider) {
      this.initDragScroll();
      this.initVideoControls();
    }
  }

  initDragScroll() {
    let isDown = false;
    let startX;
    let scrollLeft;
    let velocity = 0;
    let lastX = 0;
    let timestamp = Date.now();

    // Mouse events
    this.slider.addEventListener('mousedown', (e) => {
      isDown = true;
      this.slider.style.cursor = 'grabbing';
      startX = e.pageX - this.slider.offsetLeft;
      scrollLeft = this.slider.scrollLeft;
      velocity = 0;
      lastX = e.pageX;
      timestamp = Date.now();
      e.preventDefault();
    });

    this.slider.addEventListener('mouseleave', () => {
      if (isDown) {
        isDown = false;
        this.slider.style.cursor = 'grab';
        this.applyMomentum();
      }
    });

    this.slider.addEventListener('mouseup', () => {
      if (isDown) {
        isDown = false;
        this.slider.style.cursor = 'grab';
        this.applyMomentum();
      }
    });

    this.slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - startX) * 1.5;

      // Calculate velocity
      const now = Date.now();
      const dt = now - timestamp;
      if (dt > 0) {
        velocity = (e.pageX - lastX) / dt;
      }
      lastX = e.pageX;
      timestamp = now;

      this.slider.scrollLeft = scrollLeft - walk;
    });

    // Touch events for mobile
    let touchStartX = 0;
    let touchStartScrollLeft = 0;

    this.slider.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].pageX;
      touchStartScrollLeft = this.slider.scrollLeft;
    }, { passive: true });

    this.slider.addEventListener('touchmove', (e) => {
      const touchX = e.touches[0].pageX;
      const walk = (touchStartX - touchX);
      this.slider.scrollLeft = touchStartScrollLeft + walk;
    }, { passive: true });
  }

  applyMomentum() {
    const friction = 0.95;
    const minVelocity = 0.5;

    const scroll = () => {
      velocity *= friction;
      if (Math.abs(velocity) > minVelocity) {
        this.slider.scrollLeft -= velocity * 10;
        requestAnimationFrame(scroll);
      }
    };

    if (Math.abs(velocity) > minVelocity) {
      requestAnimationFrame(scroll);
    }
  }

  initVideoControls() {
    this.videos.forEach(video => {
      const playButton = video.parentElement.querySelector('.creator-testimonials__play-button');

      // Handle video click
      video.parentElement.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (video.paused) {
          // Pause all other videos
          this.videos.forEach(v => {
            if (v !== video && !v.paused) {
              v.pause();
              v.muted = true;
              v.removeAttribute('data-playing');
            }
          });

          // Unmute and play
          video.muted = false;
          video.play();
          video.setAttribute('data-playing', 'true');
          if (playButton) playButton.style.opacity = '0';
        } else {
          video.pause();
          video.removeAttribute('data-playing');
          if (playButton) playButton.style.opacity = '1';
        }
      });

      // Show/hide play button based on video state
      video.addEventListener('play', () => {
        video.setAttribute('data-playing', 'true');
        if (playButton) playButton.style.opacity = '0';
      });

      video.addEventListener('pause', () => {
        video.removeAttribute('data-playing');
        if (playButton) playButton.style.opacity = '1';
      });

      video.addEventListener('ended', () => {
        video.removeAttribute('data-playing');
        if (playButton) playButton.style.opacity = '1';
      });
    });
  }
}

customElements.define('creator-testimonials', CreatorTestimonials);
